<template>
    <div
        ref="content"
        :class="['overflow-tooltip-content', overflowClass]"
        :style="{'filter': isMasked ? 'blur(3px)' : ''}"
    >
        <slot>{{ content }}</slot>
        <span v-if="date" class="create-date">{{ date }}</span>
        <veui-popover
            v-if="isOverflow && !isMasked" target="content"
            v-bind="$attrs"
            overlay-class="overflow-tooltip"
        >
            <template v-if="hasTipSlot || tip">
                <slot name="tip">{{ tip }}</slot>
                <span v-if="date" class="create-date">{{ date }}</span>
            </template>
            <template v-else-if="hasDefaultSlot || content">
                <slot>{{ content }}</slot>
                <span v-if="date" class="create-date">{{ date }}</span>
            </template>
        </veui-popover>
    </div>
</template>

<script>
/**
 * @author xingminghua
 * @desc 内容溢出时才展现的Tooltip
 */
import {Popover} from 'veui';

export default {
    name: 'overflow-tooltip',
    components: {
        'veui-popover': Popover
    },
    props: {
        /**
         * default slot: 内容插槽，和content二选一
         * tip slot: 浮层内容插槽，和tip二选一。若都不存在则使用内容作为浮层内容
         * 其余props透传给veui popover
         */
        // 外层容器类
        overflowClass: {
            type: String,
            default: ''
        },
        // 内容
        content: {
            type: String,
            default: ''
        },
        date: {
            type: String,
            default: ''
        },
        // 完整描述，没有则用content
        tip: {
            type: String,
            default: ''
        },
        // 检测溢出的方向 'x'| 'y' | 'all'
        overflow: {
            type: String,
            default: 'x'
        },
        // 是否采用毛玻璃特效遮罩
        isMasked: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasTipSlot() {
            return this.$slots.tip;
        },
        hasDefaultSlot() {
            return this.$slots.default;
        }
    },
    data() {
        return {
            isOverflow: false
        };
    },
    mounted() {
        if (this.content || this.$slots.default) {
            this.calcIsOverflow();
        }
    },
    updated() {
        if (this.content || this.$slots.default) {
            this.calcIsOverflow();
        }
    },
    methods: {
        // 计算是否溢出
        calcIsOverflow() {
            if (this.$refs.content) {
                const {offsetWidth, scrollWidth, offsetHeight, scrollHeight}
                    = this.$refs.content;
                const overflowX = offsetWidth < scrollWidth;
                const overflowY = offsetHeight < scrollHeight;
                switch (this.overflow) {
                    case 'x':
                        this.isOverflow = overflowX;
                        break;
                    case 'y':
                        this.isOverflow = overflowY;
                        break;
                    case 'all':
                        this.isOverflow = overflowX || overflowY;
                        break;
                    default:
                        break;
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
// 高度限制自行加class设置
.overflow-tooltip-content {
    font-size: 16px;
    color: inherit;
    line-height: 26px;
    white-space: break-spaces;
    word-break: break-all;
    overflow: hidden; // 溢出内容隐藏
    max-width: 100%;

    // safari禁用系统tooltip提示
    &::before {
        content: "";
        display: block;
    }
}

.overflow-tooltip,
.overflow-tooltip-content {
    .create-date {
        display: inline-block;
        height: 20px;
        padding: 0 8px;
        margin-left: 6px;
        border-radius: 10px;
        background: rgba(233, 236, 243, .5);
        font-family: PingFangSC-Regular;
        color: #999;
        font-size: 14px;
        line-height: 20px !important;
        text-align: center;
    }
}

.overflow-tooltip {
    text-align: justify;
    word-break: break-all;
}
</style>
